// ============================================================================
// TagChips.tsx — чипы тегов (единый вид: карточки, формы, списки).
// Цвет тега: hex или "@имя" (справочник Цветов) — резолв через colorRefs.
// ============================================================================

import { colorRefToCss } from '@/lib/colorRefs';
import type { TagInfo } from '@/lib/tags';

export function TagChips({ tags, className }: { tags?: TagInfo[]; className?: string }) {
  if (!tags || tags.length === 0) return null;
  return (
    <div className={`flex flex-wrap gap-1 ${className || ''}`}>
      {tags.map((t) => {
        let color = '';
        try {
          color = t.color ? colorRefToCss(t.color) : '';
        } catch {
          color = '';
        }
        return (
          <span
            key={t.id}
            title={t.path || t.name}
            className="inline-flex items-center gap-1 rounded-full border border-border/60 bg-muted/40 px-1.5 py-0.5 text-[10px] leading-none text-foreground/80 max-w-[140px]"
          >
            {color && <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: color }} />}
            <span className="truncate">{t.name}</span>
          </span>
        );
      })}
    </div>
  );
}
